import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import axios from 'axios'

// 검수 대상 교재 목록. 메인 서버가 아니라 다운로드 도메인에 올린 정적 JSON 이다
export type InspectWorkbook = {
  bookId: string
  id: number
}

export const certifiedWorkbookList = {
  getInspectWorkbooks() {
    return axios.get<InspectWorkbook[]>(
      `https://download.${domainProvider.TARGET_DOMAIN}/certified-books.json`,
    )
  },
}
